(function () {
  var config = window.__COSSY_ECOMMERCE_BRIDGE__ || {};

  window.dataLayer = window.dataLayer || [];

  var CURRENCY = config.currency;
  var DEBUG = false;

  /*
    Dedupe config:
    - submit listener fires immediately
    - AJAX listener fires after /cart/add response
    - both can represent the same Add to cart action
  */
  var ADD_TO_CART_DEDUPE_MS = 2500;
  var recentAddToCartEvents = {};

  function log() {
    if (DEBUG) {
      console.log.apply(console, ["[Storefront Ecommerce]"].concat(Array.prototype.slice.call(arguments)));
    }
  }

  function moneyToNumber(value) {
    if (value === undefined || value === null) return 0;

    if (typeof value === "number") {
      // Shopify Liquid prices are usually in cents/subunits.
      return Number((value / 100).toFixed(2));
    }

    var cleaned = String(value)
      .replace(/\s/g, "")
      .replace(",", ".")
      .replace(/[^\d.]/g, "");

    return Number(cleaned || 0);
  }

  function now() {
    return new Date().getTime();
  }

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  function getDedupeKey(eventName, ecommerce) {
    var item = ecommerce && ecommerce.items && ecommerce.items[0] ? ecommerce.items[0] : {};
    var id = item.item_id || item.variant_id || item.id || "no-id";
    var qty = item.quantity || 1;
    var value = ecommerce && ecommerce.value !== undefined ? ecommerce.value : "no-value";

    return [eventName, id, qty, value].join(":");
  }

  function shouldSkipDedupe(eventName, ecommerce) {
    if (eventName !== "add_to_cart") {
      return false;
    }

    var key = getDedupeKey(eventName, ecommerce);
    var currentTime = now();
    var lastTime = recentAddToCartEvents[key];

    recentAddToCartEvents[key] = currentTime;

    // Cleanup old keys.
    Object.keys(recentAddToCartEvents).forEach(function (storedKey) {
      if (currentTime - recentAddToCartEvents[storedKey] > 10000) {
        delete recentAddToCartEvents[storedKey];
      }
    });

    if (lastTime && currentTime - lastTime < ADD_TO_CART_DEDUPE_MS) {
      log("duplicate skipped", key);
      return true;
    }

    return false;
  }

  function pushEcommerceEvent(eventName, ecommerce) {
    if (shouldSkipDedupe(eventName, ecommerce)) {
      return;
    }

    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: eventName,
      ecommerce: ecommerce,
    });

    log("pushed", eventName, ecommerce);
  }

  function pushDataLayerEvent(eventName, data) {
    data = data || {};
    data.event = eventName;

    window.dataLayer.push(data);

    log("pushed", eventName, data);
  }

  function normalizeItem(item) {
    return {
      item_id: item.item_id || item.sku || item.variant_id || item.id,
      variant_id: item.variant_id || item.id,
      item_name: item.item_name || item.product_title || item.title,
      item_variant: item.item_variant || item.variant_title || item.variant,
      item_brand: item.item_brand || item.vendor,
      item_category: item.item_category || item.product_type || item.type,
      price: Number(item.price || 0),
      quantity: Number(item.quantity || 1),
    };
  }

  function getFormQuantity(form) {
    var quantityInput = form.querySelector('[name="quantity"]');
    return quantityInput ? Number(quantityInput.value || 1) : 1;
  }

  function getVariantIdFromForm(form) {
    var variantInput = form.querySelector('[name="id"]');
    return variantInput ? String(variantInput.value) : null;
  }

  function getProductData() {
    return config.product || window.__COSSY_PRODUCT_DATA__ || null;
  }

  function buildProductItemFromVariantId(variantId, quantity) {
    var product = getProductData();

    if (!product) {
      return null;
    }

    var variants = product.variants || [];

    var variant =
      variants.find(function (v) {
        return String(v.id) === String(variantId);
      }) || variants[0];

    if (!variant) {
      return null;
    }

    return normalizeItem({
      item_id: variant.sku || variant.id,
      variant_id: variant.id,
      item_name: product.title,
      item_variant: variant.title,
      item_brand: product.vendor,
      item_category: product.type,
      price: moneyToNumber(variant.price),
      quantity: quantity || 1,
    });
  }

  function pushAddToCartFromForm(form) {
    var variantId = getVariantIdFromForm(form);
    var quantity = getFormQuantity(form);
    var item = buildProductItemFromVariantId(variantId, quantity);

    if (!item) {
      item = normalizeItem({
        item_id: variantId,
        variant_id: variantId,
        item_name: document.title,
        price: 0,
        quantity: quantity,
      });
    }

    pushEcommerceEvent("add_to_cart", {
      currency: CURRENCY,
      value: Number((item.price * item.quantity).toFixed(2)),
      items: [item],
    });
  }

  function pushAddToCartFromCartResponse(cartItem) {
    if (!cartItem) return;

    var item = normalizeItem({
      item_id: cartItem.sku || cartItem.variant_id || cartItem.id,
      variant_id: cartItem.variant_id,
      item_name: cartItem.product_title || cartItem.title,
      item_variant: cartItem.variant_title,
      item_brand: cartItem.vendor,
      item_category: cartItem.product_type,
      price: moneyToNumber(cartItem.final_price || cartItem.price),
      quantity: cartItem.quantity || 1,
    });

    pushEcommerceEvent("add_to_cart", {
      currency: CURRENCY,
      value: Number((item.price * item.quantity).toFixed(2)),
      items: [item],
    });
  }

  function pushViewItem() {
    var product = getProductData();

    if (!product) return;

    window.__COSSY_PRODUCT_DATA__ = product;

    var urlVariant = new URLSearchParams(window.location.search).get("variant");
    var selectedVariantId = urlVariant || product.selectedVariantId;
    var item = buildProductItemFromVariantId(selectedVariantId, 1);

    if (!item) return;

    pushEcommerceEvent("view_item", {
      currency: CURRENCY,
      value: item.price,
      items: [item],
    });
  }

  function pushSearch() {
    var search = config.search;

    if (!search || !search.search_term) return;

    pushDataLayerEvent("search", {
      search_term: search.search_term,
    });
  }

  function normalizeCollectionItem(item, index) {
    var collection = config.collection || {};
    var normalizedItem = normalizeItem({
      item_id: item.item_id,
      variant_id: item.variant_id,
      item_name: item.item_name,
      item_variant: item.item_variant,
      item_brand: item.item_brand,
      item_category: item.item_category,
      price: moneyToNumber(item.price),
      quantity: item.quantity || 1,
    });

    if (collection.item_list_id) {
      normalizedItem.item_list_id = collection.item_list_id;
    }

    if (collection.item_list_name) {
      normalizedItem.item_list_name = collection.item_list_name;
    }

    normalizedItem.index = item.index !== undefined && item.index !== null ? Number(item.index) : index + 1;

    return normalizedItem;
  }

  function pushViewItemList() {
    var collection = config.collection;

    if (!collection || !collection.items || !collection.items.length) return;

    var itemListId = collection.item_list_id;
    var itemListName = collection.item_list_name;

    var items = collection.items.map(normalizeCollectionItem);

    pushEcommerceEvent("view_item_list", {
      currency: CURRENCY,
      item_list_id: itemListId,
      item_list_name: itemListName,
      items: items,
    });
  }

  function getVariantIdFromUrl(url) {
    try {
      return new URL(url, window.location.origin).searchParams.get("variant");
    } catch (e) {
      return null;
    }
  }

  function isCollectionProductLink(link) {
    if (!link || !link.href || !link.closest) return false;

    if (!link.closest(".listing__grid") || !link.closest("product-card")) return false;

    if (!link.classList.contains("product-card__media") && !link.closest(".product-card__heading")) return false;

    try {
      return new URL(link.href, window.location.origin).pathname.indexOf("/products/") !== -1;
    } catch (e) {
      return false;
    }
  }

  function getCollectionItemIndexFromLink(link, variantId) {
    var collection = config.collection;

    if (collection && collection.items && collection.items.length && variantId) {
      for (var i = 0; i < collection.items.length; i++) {
        if (String(collection.items[i].variant_id) === String(variantId)) {
          return i;
        }
      }
    }

    var card = link.closest("product-card");
    var grid = link.closest(".listing__grid");
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll("product-card")) : [];

    return cards.indexOf(card);
  }

  function buildCollectionItemFromCard(card) {
    if (!card || !card.dataset || !card.dataset.variantId) return null;

    return {
      item_id: card.dataset.itemId,
      variant_id: card.dataset.variantId,
      item_name: card.dataset.itemName,
      item_variant: card.dataset.itemVariant,
      item_brand: card.dataset.itemBrand,
      item_category: card.dataset.itemCategory,
      price: card.dataset.price,
      quantity: 1,
    };
  }

  function pushSelectItemFromCollectionLink(link) {
    var collection = config.collection;

    if (!collection) return;

    var variantId = getVariantIdFromUrl(link.href);
    var itemIndex = getCollectionItemIndexFromLink(link, variantId);
    var card = link.closest("product-card");
    var itemData = collection.items && collection.items[itemIndex] ? collection.items[itemIndex] : buildCollectionItemFromCard(card);

    if (!itemData) return;

    var item = normalizeCollectionItem(itemData, itemIndex);

    if (variantId) {
      item.variant_id = variantId;
    }

    pushEcommerceEvent("select_item", {
      currency: CURRENCY,
      item_list_id: collection.item_list_id,
      item_list_name: collection.item_list_name,
      items: [item],
    });
  }

  function handleCollectionItemClick(event) {
    var link = event.target && event.target.closest ? event.target.closest("a[href]") : null;

    if (!isCollectionProductLink(link)) return;

    pushSelectItemFromCollectionLink(link);
  }

  function pushViewCart() {
    var cart = config.cart;

    if (!cart) return;

    var items = (cart.items || []).map(function (item) {
      return normalizeItem({
        item_id: item.item_id,
        variant_id: item.variant_id,
        item_name: item.item_name,
        item_variant: item.item_variant,
        item_brand: item.item_brand,
        item_category: item.item_category,
        price: moneyToNumber(item.price),
        quantity: item.quantity,
      });
    });

    pushEcommerceEvent("view_cart", {
      currency: CURRENCY,
      value: moneyToNumber(cart.totalPrice),
      items: items,
    });
  }

  if (config.product) {
    onReady(pushViewItem);
  }

  if (config.collection) {
    onReady(pushViewItemList);
    document.addEventListener("click", handleCollectionItemClick, true);
  }

  if (config.search) {
    onReady(pushSearch);
  }

  if (config.cart) {
    pushViewCart();
  }

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;

      if (!form || !form.matches('form[action*="/cart/add"]')) {
        return;
      }

      pushAddToCartFromForm(form);
    },
    true
  );

  if (window.fetch) {
    var originalFetch = window.fetch;

    window.fetch = function () {
      var args = arguments;
      var requestUrl = "";

      try {
        requestUrl = typeof args[0] === "string" ? args[0] : args[0].url;
      } catch (e) {}

      return originalFetch.apply(this, args).then(function (response) {
        try {
          if (requestUrl && requestUrl.indexOf("/cart/add") !== -1) {
            response
              .clone()
              .json()
              .then(function (data) {
                if (data && data.items && data.items.length) {
                  data.items.forEach(pushAddToCartFromCartResponse);
                } else {
                  pushAddToCartFromCartResponse(data);
                }
              })
              .catch(function () {});
          }
        } catch (e) {}

        return response;
      });
    };
  }

  if (window.XMLHttpRequest) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cossyRequestUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;

      xhr.addEventListener("load", function () {
        try {
          if (
            xhr.__cossyRequestUrl &&
            String(xhr.__cossyRequestUrl).indexOf("/cart/add") !== -1 &&
            xhr.responseText
          ) {
            var data = JSON.parse(xhr.responseText);

            if (data && data.items && data.items.length) {
              data.items.forEach(pushAddToCartFromCartResponse);
            } else {
              pushAddToCartFromCartResponse(data);
            }
          }
        } catch (e) {}
      });

      return originalSend.apply(this, arguments);
    };
  }
})();
